import params from '../../../setup/config/params.json'
import QRCodeGenerator from '../index'
import { IMAGE_SOURCE_PATH } from '../../../setup/config/env'
const routes = {
    qrCode: {
        path: '/qr-code-generator',
        component: QRCodeGenerator,
        exact: true,
        auth: true,
        role: params.user.roles.admin.key,
        module: "utilities",
        subModule: "qrGenerator",
        action: "canView",
    }    
}

export function getImageSource(image = '/default.jpg') {
    return `${ IMAGE_SOURCE_PATH }${ image }`
}

export default routes